import clsx from 'clsx';

import { Props } from '../components/buttons/IconButton';

const iconSizeMapping = {
  medium: 'IconButton-icon--medium',
  large: 'IconButton-icon--large',
};

export function classNameForIconButtonProps(props: Props) {
  const { hideText, modifierClassName } = props;

  return clsx(modifierClassName, {
    IconButton: props.IconComponent,
    'IconButton-visibleText': !hideText,
  });
}

export function classNameForIconButtonIconProps(props: Props) {
  const { className, disabled, iconSize } = props;
  const sizeClassName = iconSize ? iconSizeMapping[iconSize] || '' : '';

  return clsx('IconButton-icon', className, sizeClassName, {
    'is-disabled': disabled,
  });
}
